import { Grid, Typography } from 'ui';

import type { SiteMaterialDemandSignalMatch } from '../../hooks/useMatchedMaterialsWithOffers/useMatchedMaterialsWithOffers';
import { MatchedSiteMaterialDemandSignalItem } from '../MatchedSiteMaterialDemandSignalItem/MatchedSiteMaterialDemandSignalItem';

export const MatchedSiteMaterialsList = ({
  materials,
  targetMargin,
}: {
  materials?: SiteMaterialDemandSignalMatch[];
  targetMargin?: number;
}) => {
  if (!materials || materials.length === 0) {
    return <Typography textAlign="center">No materials found</Typography>;
  }

  return (
    <Grid container data-testid="matched-site-materials-list" spacing={2}>
      {materials.map(({ demandSignal, siteMaterial, supplySignal, sellerOffer, buyerOffer }) => (
        <Grid
          item
          xs={12}
          key={`site-material-demand-signal-match-${siteMaterial.id}-${demandSignal.id}-${supplySignal?.id}`}
          data-testid={`material-item-${siteMaterial.id}-${demandSignal.id}-${supplySignal?.id}`}
        >
          <MatchedSiteMaterialDemandSignalItem
            demandSignal={demandSignal}
            siteMaterial={siteMaterial}
            supplySignal={supplySignal}
            sellerOffer={sellerOffer}
            buyerOffer={buyerOffer}
            targetMargin={targetMargin}
          />
        </Grid>
      ))}
    </Grid>
  );
};
